var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68994 1.6886C1.68994 1.53941 1.7492 1.39634 1.85469 1.29085C1.96018 1.18536 2.10326 1.1261 2.25244 1.1261H15.7524C15.9016 1.1261 16.0447 1.18536 16.1502 1.29085C16.2557 1.39634 16.3149 1.53941 16.3149 1.6886V3.9386C16.3149 4.07732 16.2636 4.21114 16.1709 4.31435L11.2524 9.7796V15.1886C11.2524 15.3066 11.2151 15.4216 11.1461 15.5173C11.0771 15.613 10.9797 15.6846 10.8677 15.7218L7.49269 16.8468C7.40817 16.875 7.31818 16.8827 7.23012 16.8692C7.14205 16.8558 7.05844 16.8216 6.98616 16.7696C6.91388 16.7175 6.855 16.649 6.81437 16.5697C6.77373 16.4905 6.75251 16.4027 6.75244 16.3136V9.7796L1.83394 4.31435C1.74125 4.21114 1.68997 4.07732 1.68994 3.9386V1.6886ZM2.81494 2.2511V3.7226L7.73344 9.18785C7.82613 9.29106 7.87742 9.42488 7.87744 9.5636V15.5328L10.1274 14.7836V9.5636C10.1275 9.42488 10.1788 9.29106 10.2714 9.18785L15.1899 3.7226V2.2511H2.81494Z",
    fill: "#084298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag_icon.2ddaaa10e03051f2bcf4c8b580389d35.svg";
export { ForwardRef as ReactComponent };